import indiaFlag from "../assests/page/Flag_of_India 1.svg";
import italyFlag from "../assests/page/Flag_of_Italy 1.svg";
import germanyFlag from "../assests/page/Flag-Germany 1.svg";
import franceFlag from "../assests/page/Flag-France 1.svg";
import chinaFlag from "../assests/page/Flag_of_the_People's_Republic_of_China 1.svg";
import spainFlag from "../assests/page/Flag_of_Spain 1.svg";
import unitedStatesFlag from "../assests/page/Flag-United-States-of-America 1.svg";
import unitedKingdomFlag from "../assests/page/Flag_of_the_United_Kingdom_(1-2) 1.svg";
import errorIcon from "../assests/overlay/error-icon.svg";
import successIcon from "../assests/overlay/success-icon.svg";
import { toast } from "react-toastify";

export const minimumScreenForMobile = 300; //iphone 4??
export const maximumScreenForMobile = 1250;

export const searchFilterTypes = {
  "By Categories": ["Stocks", "Structured Products", "Bonds", "Funds"],
};

//id must be unique for each language
export const Languages = [
  { id: "hindi", name: "Hindi", icon: indiaFlag },
  { id: "italian", name: "Italian", icon: italyFlag },
  { id: "chinese", name: "Chinese", icon: chinaFlag },
  { id: "french", name: "French", icon: franceFlag },
  { id: "german", name: "German", icon: germanyFlag },
  { id: "spanish", name: "Spanish", icon: spainFlag },
  { id: "engllish-us", name: "English", label: "US", icon: unitedStatesFlag },
  { id: "engllish-uk", name: "English", label: "UK", icon: unitedKingdomFlag },
];

export const allCountriesApi = "https://restcountries.com/v3.1/all";

export const restfulCountriesApi =
  "https://restfulcountries.com/api/v1/countries";

export const allCurrenciesApi =
  "https://api.exchangerate-api.com/v4/latest/USD";

export const sponsorTxUrl = "https://gateway.verified.network/api/sponsor";

export const pagesWithGeneralSearch = [
  // "/investments/portfolio",
  "/investments/assets",
];

export const pagesWithoutFooter = [
  "/add-funds-method",
  "/withdraw-funds-method",
];

export const kycAuthenticationChain = 8453;

export const pagesWithoutProfileIcon = ["/investments"];
export const pagesWithoutHeader = ["/verify-kyc", "/dashboard/verify-kyc"];

export const popularCountries = [
  "India".toLocaleLowerCase(),
  "United Kingdom".toLocaleLowerCase(),
  "United States of America".toLocaleLowerCase(),
  "Australia".toLocaleLowerCase(),
];

export const PoolType = {
  primaryPool: "PrimaryIssue",
  secondaryPool: "SecondaryIssue",
  marginPool: "MarginIssue",
};

export const currenciesToFiat = {
  USDC: "USD",
  USDT: "USD",
  DAI: "USD",
  ETH: "ETH",
};

//TODO: Add more
export const currenciesToSymbol = {
  USD: "$",
  INR: "₹",
  GBP: "£",
  EUR: "€",
  AUD: "$",
  CAD: "$",
  NGN: "₦",
  CHF: "CHF",
  "sepolia eth": "ETH",
  "mainnet eth": "ETH",
  mainnet: "ETH",
  eth: "ETH",
  "base eth": "ETH",
  base: "ETH",
  "base mainnet eth": "ETH",
  wsteth: "ETH",
  steth: "ETH",
  gnosis: "$", //Dai
  wstETH: "ETH",
  stETH: "ETH",
  USDC: "$",
  USDT: "$",
  DAI: "$",
};

//TODO: Add more
export const securityCategories =
  process.env.REACT_APP_NODE_ENV === "production"
    ? ["Stocks", "Bonds", "Funds", "CFD"]
    : [
        "Stocks",
        "Bonds",
        "Funds",
        "CFD",
        // "Equites/Options/Fixed-Income/Mutual-Funds",
      ];

export const secondaryCategories = ["Stocks", "Bonds"];

export const securityCategoriesAlias = {
  // stock: "Equities",
  // bond: "Credit",
  stock: "Fixed Income Products",
  bond: "Fixed Income Products",
  funds: "Fixed Income Products",
  cfd: "Derivatives",
  amc: "Active Managed Certificates",
};
export const stripeSupportedCountriesCode = [
  "AU",
  "AT",
  "BE",
  "BR",
  "BG",
  "CA",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HK",
  "HU",
  "IE",
  "IT",
  "JP",
  "LV",
  "LT",
  "LU",
  "MT",
  "MX",
  "NL",
  "NZ",
  "NO",
  "PL",
  "PT",
  "RO",
  "SG",
  "SK",
  "SI",
  "ES",
  "SE",
  "CH",
  "GB",
  "US",
]; //stripe supported country codes in uppercase

export const paraswapTokensBaseUrl = "https://api.paraswap.io/tokens";

export const getErrorToastContent = (title, content, link, linkClickFunc) => {
  return (
    <div className="general-web-toast-error">
      <div className="general-web-toast-error-cont">
        <img src={errorIcon} alt="" />
        <div className="general-web-toast-error-container">
          <p className="general-web-toast-error-title">{title}</p>
          <p className="general-web-toast-error-label">{content}</p>
        </div>
      </div>

      {link && (
        <div
          style={{ minWidth: "fit-content", cursor: "pointer" }}
          className="general-web-toast-success-link"
          onClick={() => {
            console.log("cllllllllllllll", linkClickFunc);
            linkClickFunc ? linkClickFunc() : console.log();
          }}
        >
          {link}
        </div>
      )}
    </div>
  );
};

export const getSuccessToastContent = (title, content, link) => {
  return (
    <div className="general-web-toast-success">
      <div className="general-web-toast-success-cont">
        <img src={successIcon} alt="" />
        <div className="general-web-toast-success-container">
          <p className="general-web-toast-error-title">{title}</p>
          <p className="general-web-toast-error-label">{content}</p>
        </div>
      </div>
      {link?.length > 0 && (
        <div className="general-web-toast-success-link">
          <a
            className="general-web-toast-success-link-text"
            href={link}
            target="_blank"
            rel="noreferrer"
          >
            Follow your transaction.
          </a>
        </div>
      )}
    </div>
  );
};

export const errorToast = (title, content, linkElement, linkClickFunc) => {
  toast.dismiss();
  return toast.error(
    getErrorToastContent(title, content, linkElement, linkClickFunc),
    {
      closeButton: true,
      position: "top-left",
      style: {
        background: "#fef2f2",
        width: "100%",
      },
      icon: false,
      closeOnClick: linkElement ? false : true,
    },
  );
};

export const successToast = (title, content, link) => {
  toast.dismiss();
  return toast.success(getSuccessToastContent(title, content, link), {
    closeButton: true,
    position: "top-left",
    style: {
      background: "var(--Success-50, #F1F8ED)",
      width: "100%",
    },
    icon: false,
  });
};

export const paraswapUnsupportedChains = [11155111];

export const verifiedAmcBaseUrl =
  "https://gateway.verified.network/api/verified-amc";

export const verifiedGTNBaseUrl = "https://gateway.verified.network/api/gtn";

export const verifiedMoneyHubBaseUrl =
  "https://gateway.verified.network/api/moneyhub";

export const verifiedBlinkBaseUrl =
  "https://gateway.verified.network/api/blink";

export const verifiedIniciadorBaseUrl =
  "https://gateway.verified.network/api/iniciador";

export const verifiedBrokerageUrl = "https://gateway.verified.network/api";

export const coinbaseCurrencyChartBaseUrl =
  "https://api.coinbase.com/v2/products";

export const verifiedPaymentGateWayUrl =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://verified.azurewebsites.net/api/paymentgateway"
    : "https://verified-kyc.azurewebsites.net/api/paymentgateway";

export const verifiedCountryApiUrl =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://verified.azurewebsites.net/api/country"
    : "https://verified-kyc.azurewebsites.net/api/country";

export const rateBucketName = "oracle-rates";

export const moneyHubContinents = ["europe"]; //continents in lowercase

export const moneyHubAllConnectionsUrl =
  "https://identity.moneyhub.co.uk/oidc/.well-known/all-connections";

export const moneyHubTestConnectionUrl =
  "https://identity.moneyhub.co.uk/oidc/.well-known/test-connections";

export const biconomyPaymasterEndpoint =
  "https://paymaster-dashboard-backend.prod.biconomy.io/api/v2/public/sdk/paymaster";

export const biconomyWhitelistEndpoint =
  "https://paymaster-dashboard-backend.prod.biconomy.io/api/v2/public/sdk/smart-contract";

export const verifiedHexTrustEndpoint =
  "https://gateway.verified.network/api/hextrust";

export const verifiedOrbisEndpoint =
  "https://gateway.verified.network/api/orbis";

export const stripeLogoUrl =
  "https://images.stripeassets.com/fzn2n1nzq965/HTTOloNPhisV9P4hlMPNA/cacf1bb88b9fc492dfad34378d844280/Stripe_icon_-_square.svg";

export const blinkIconBase64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAb1BMVEXeOhreORneOBjfPh7gRynhTTDiUTXiUjfri3n0vbH42NH64t3gQiT53df//fz////yrqH++vnul4bpfWj87uvma1P75+P3z8fum4vrhnPqhHDjWkD99vT1x73ys6bncFnkX0XvoZLtlILnc130vrQrQ1gaAAAAwUlEQVR4AdWRRRIDMRAD4/EyM/Pu/78Y8oTlB0TXlsrV49O/Rwgi0lIiaZiWZWnHtuN6/jWYU+CEUXwP3htJGnMgDxKeawoy472mIPLiQaMo+uVUVoqmddN23S/vPcWHxiBwKDJH3jeSoMDEz0+BQFw2LDCaBC/QDop7PeQ0s0A1Y76ELNAJyK2aBTKJf+ghkGgEVixAnGDTCPQqu8u8Kr8EChXGcZF/v8+Ak25PAAsREPjgk8EcF4qGOS4UxywBvwDNMRQyixYcrAAAAABJRU5ErkJggg==";

export const smsSenderUrl =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://verified.azurewebsites.net/api/smssender"
    : "https://verified-kyc.azurewebsites.net/api/smssender";

export const nearContractProd = "v2.ref‑finance.near";

export const emailSenderUrl =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://verified.azurewebsites.net/api/emailsender"
    : "https://verified-kyc.azurewebsites.net/api/emailsender";

export const otpSender =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://verified.azurewebsites.net/api/otpsender"
    : "https://verified-kyc.azurewebsites.net/api/otpsender";

export const defaultVerifiedUrl =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://wallet.verified.network"
    : "https://veripay-bac0b.web.app";

export const coingeckoListUrl = "https://api.coingecko.com/api/v3/coins/list";

export const coingeckoPriceUrl =
  "https://api.coingecko.com/api/v3/simple/price";

export const coinbasePriceUrl = "https://api.coinbase.com/v2/prices";

export const verifiedWalletDownloadLink =
  "https://chromewebstore.google.com/detail/verified-wallet/abkgckcpmnbipkfhkkchkdfkmccjdmkh";

export const coingeckoDefaultIds = [
  { id: "bitcoin", symbol: "btc" },
  { id: "ethereum", symbol: "eth" },
  { id: "ripple", symbol: "xrp" },
  { id: "binancecoin", symbol: "bnb" },
  { id: "binance-usd-linea", symbol: "bus" },
  { id: "solana", symbol: "sol" },
  { id: "dogecoin", symbol: "doge" },
  { id: "dogecoin", symbol: "dog" },
  { id: "cardano", symbol: "ada" },
  { id: "chainlink", symbol: "lnk" },
  { id: "chainlink", symbol: "link" },
  { id: "tron", symbol: "trx" },
  { id: "avalanche-2", symbol: "avax" },
  { id: "bitcoin-cash", symbol: "bch" },
  { id: "litecoin", symbol: "ltc" },
  { id: "polkadot", symbol: "dot" },
  { id: "uniswap", symbol: "uni" },
  { id: "aptos", symbol: "apt" },
  { id: "leo-token", symbol: "leo" },
  { id: "stellar", symbol: "xlm" },
  { id: "sui", symbol: "sui" },
  { id: "aave", symbol: "aave" },
  { id: "algorand", symbol: "algo" },
  { id: "apecoin", symbol: "ape" },
  { id: "cosmos", symbol: "atm" },
  { id: "basic-attention-token", symbol: "bat" },
  { id: "bonk", symbol: "bnk" },
  { id: "compound-governance-token", symbol: "comp" },
  { id: "compound-governance-token", symbol: "cmp" },
  { id: "curve-dao-token", symbol: "crv" },
  { id: "dai", symbol: "dai" },
  { id: "decentraland", symbol: "man" },
  { id: "dogwifcoin", symbol: "wif" },
  { id: "eos", symbol: "eos" },
  { id: "gala", symbol: "gala" },
  { id: "the-graph", symbol: "grt" },
  { id: "kusama", symbol: "ksm" },
  { id: "loopring", symbol: "lrc" },
  { id: "maker", symbol: "mkr" },
  { id: "moonbeam", symbol: "glm" },
  { id: "moonbeam", symbol: "glmr" },
  { id: "near", symbol: "ner" },
  { id: "near", symbol: "near" },
  { id: "pepe", symbol: "pep" },
  { id: "pepe", symbol: "pepe" },
  { id: "matic-network", symbol: "mat" },
  { id: "matic-network", symbol: "matic" },
  { id: "shiba-inu", symbol: "shb" },
  { id: "shiba-inu", symbol: "shib" },
  { id: "starknet", symbol: "str" },
  { id: "starknet", symbol: "strk" },
  { id: "sushi", symbol: "sus" },
  { id: "sushi", symbol: "sushi" },
  { id: "tezos", symbol: "xtz" },
  { id: "the-sandbox", symbol: "snd" },
  { id: "the-sandbox", symbol: "sand" },
  { id: "official-trump", symbol: "trump" },
  { id: "ripple", symbol: "xrp" },
  { id: "xdce-crowd-sale", symbol: "xdc" },
];

export const tokenGcexAlias = {
  SHIB: "SHB",
  SAND: "SND",
  GLMR: "GLM",
  COMP: "CMP",
  LINK: "LNK",
};

export const KYCTexts = {
  underReview:
    "Your profile is currently under review by our Compliance team. Please be patient you will receive an email notification once the review is complete. Thank you for your understanding.",
  resubmission:
    "We were unable to verify your profile. Resubmission is required, please click on 'Fix Rejection' to update and resubmit your profile. Thank you.",
  kycSubmitted:
    "Thank you for completing your KYC. You will receive an email after your KYC submission is approved.",
  waitForEmail:
    "After KYC approval, you can add funds to your account with Debit/Card cards or your Bank to use Verified Network.",
  waitForEmailCustody:
    "You will also receive a follow up email from HexTrust on how to activate you Instituional Custody account, after account activation you can add funds to your account with Debit/Credit Cards or your favorite Bank to use Verified Network.",
};

export const kycSubStep1Details = {
  name: "",
  type: "",
  intendedUse: "",
  dateOfIncorporation: "",
  registrationNumber: "",
  registeredAddress: "",
  countryOfRegistration: "",
  sharePerc: "",
  votingPerc: "",
  email: "",
  website: "",
  hasTaxId: "",
  isPep: "",
  taxResidency: "",
  pepName: "",
  pepRelationship: "",
  taxId: "",
  wbenDoc: {
    hash: "",
    name: "W-8BEN",
    size: "",
    orName: "",
  },
  sofDoc: {
    hash: "",
    name: "Proof of Source of Fund",
    size: "",
    orName: "",
  },
};

export const kycSubStep4Details = {
  name: "",
  residentialAddress: "",
  nationality: "",
  countryOfResidence: "",
  email: "",
  position: "",
  // hasTaxId: "",
  isPep: "",
  // taxId: "",
  dob: "",
  sharePerc: "",
  votingPerc: "",
  pepName: "",
  pepRelationship: "",
  poiDoc: {
    hash: "",
    name: "Proof of Identity (POI)",
    size: "",
    orName: "",
  },
  poaDoc: {
    hash: "",
    name: "Proof of Address (POA)",
    size: "",
    orName: "",
  },
  sofDoc: {
    hash: "",
    name: "Proof of Source of Fund",
    size: "",
    orName: "",
  },
  wbeneDoc: {
    hash: "",
    name: "W-8BEN-E",
    size: "",
    orName: "",
  },
  emailSent: "",
};

export const kycSubStep3Details = {
  name: "",
  residentialAddress: "",
  nationality: "",
  countryOfResidence: "",
  taxResidency: "",
  position: "",
  email: "",
  hasTaxId: "",
  isPep: "",
  taxId: "",
  pepName: "",
  pepRelationship: "",
  poiDoc: {
    hash: "",
    name: "Proof of Identity (POI)",
    size: "",
    orName: "",
  },
  poaDoc: {
    hash: "",
    name: "Proof of Address (POA)",
    size: "",
    orName: "",
  },
};

export const kycSubStep5Details = {
  financialLicenced: "",
  porDoc: {
    hash: "",
    name: "Proof of Regulation (POR)",
    size: "",
    orName: "",
  },
  stChartDoc: {
    hash: "",
    name: "Structure Chart",
    size: "",
    orName: "",
  },
  artAssDoc: {
    hash: "",
    name: "Article of Associations",
    size: "",
    orName: "",
  },
  regSthldDoc: {
    hash: "",
    name: "Register of Stakeholder",
    size: "",
    orName: "",
  },
  finStmtDoc: {
    hash: "",
    name: "Financial Statements",
    size: "",
    orName: "",
  },
  fatCrsDoc: {
    hash: "",
    name: "FATCA-CRS",
    size: "",
    orName: "",
  },
  incCertDoc: {
    hash: "",
    name: "Incorporation Certificate",
    size: "",
    orName: "",
  },
  aslDoc: {
    hash: "",
    name: "Authorised Signatory List",
    size: "",
    orName: "",
  },
  constDoc: {
    hash: "",
    name: "Constitutional Documents",
    size: "",
    orName: "",
  },
  addEvdDoc: {
    hash: "",
    name: "Address Evidence",
    size: "",
    orName: "",
  },
  licDoc: {
    hash: "",
    name: "Licence",
    size: "",
    orName: "",
  },
  busEvdDoc: {
    hash: "",
    name: "Business Evidence",
    size: "",
    orName: "",
  },
  soiDoc: {
    hash: "",
    name: "Sale or Inheritance Document",
    size: "",
    orName: "",
  },
};

export const kycSubStep6Details = {
  firstWalletAddress: "",
  firstWalletType: "",
  secondWalletAddress: "",
  secondWalletType: "",
  thirdWalletAddress: "",
  thirdWalletType: "",
  fourthWalletAddress: "",
  fourthWalletType: "",
};

export const walletAddressTypes = [
  {
    name: "Ethereum",
    description: "Ethereum(mainnet, testnet), Base(mainnet testnet) e.t.c ",
  },
  {
    name: "Solana",
    description: "Solana(mainnet, testnet), Solana L2 chains, e.t.c",
  },
  { name: "Bitcoin", description: "Bitcoin wallet" },
  { name: "Near", description: "Near(mainnet, testnet) wallet" },
  { name: "Other", description: "For wallat type not listed" },
];
export const intendedUseTypes = [
  {
    name: "Investing",
    description: "Long-term asset growth and wealth management.",
  },
  {
    name: "Market Making",
    description: "Providing liquidity and depth to the order books.",
  },
  {
    name: "Trading",
    description:
      "High-frequency or short-term speculative buy and sell operations.",
  },
  {
    name: "Custody",
    description:
      "Secure, institutional-grade storage and protection of digital assets.",
  },
  {
    name: "Issuing",
    description:
      "Minting, launching, or deploying new assets and tokenized products.",
  },
];
export const entityTypeTypes = [
  {
    name: "Company",
    description: "For registered companies",
  },
  {
    name: "Fund",
    description: "For investment funds and managed funds",
  },
  {
    name: "Partnership",
    description: "For partnerships and joint ventures",
  },
  {
    name: "Trust",
    description: "For trusts and trust-managed entities",
  },
  {
    name: "Other",
    description: "For other legal entity types",
  },
];
export const entityNoDesTypeTypes = [
  {
    name: "Company",
  },
  {
    name: "Fund",
  },
  {
    name: "Partnership",
  },
  {
    name: "Trust",
  },
  {
    name: "Other",
  },
];
export const IndividualTypeTypes = [
  {
    name: "Professional",
    description: "Meets professional investment thresholds.",
  },
  {
    name: "Retail",
    description: "Individual investor seeking retailing",
  },
];
export const entityPositionTypes = [
  {
    name: "Managing Director",
    description: "Oversees operations.",
  },
  {
    name: "Director",
    description: "Participates in board governance and policy.",
  },
  {
    name: "Authorized Signatory",
    description: "Legally empowered to sign contracts.",
  },
  {
    name: "Compliance/AML Officer",
    description: "Manages KYC checks and AML policies.",
  },
  {
    name: "Beneficial Owner",
    description: "Holds significant equity or control over the entity.",
  },
  {
    name: "Other",
    description: "For other positions not listed.",
  },
];
export const relationshipTypes = [
  {
    name: "Spouse / Partner",
    // description: "Legal spouse or  companion.",
  },
  {
    name: "Parent / Guardian",
    // description: "Mother, father or guardian.",
  },
  {
    name: "Child",
    // description: "Biological, adopted, or stepchild.",
  },
  {
    name: "Sibling",
    // description: "Brother, sister, or half-sibling.",
  },
  {
    name: "Extended Family",
    // description: "Uncle, aunt, cousin e.t.c",
  },
  {
    name: "Other",
    // description: "Relationship not listed.",
  },
];

//using average days of 30.44 days per month
export const timeInSeconds = {
  "3m": 7884000,
  "6m": 15768000,
  "1y": 31536000,
  "2y": 63072000,
  "4y": 126144000,
};

export const timeSelections = ["Days", "Months", "Years"];

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const countriesDetails = [
  {
    name: "Afghanistan",
    code: "AF",
    currency: "AFN",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/af.webp",
    phone_code: "93",
  },
  {
    name: "Albania",
    code: "AL",
    currency: "ALL",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/al.webp",
    phone_code: "355",
  },
  {
    name: "Algeria",
    code: "DZ",
    currency: "DZD",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/dz.webp",
    phone_code: "213",
  },
  {
    name: "American Samoa",
    code: "AS",
    currency: "USD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/as.webp",
    phone_code: "1-684",
  },
  {
    name: "Andorra",
    code: "AD",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/ad.webp",
    phone_code: "376",
  },
  {
    name: "Angola",
    code: "AO",
    currency: "AOA",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ao.webp",
    phone_code: "244",
  },
  {
    name: "Anguilla",
    code: "AI",
    currency: "XCD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/ai.webp",
    phone_code: "1-264",
  },
  // {
  //   name: "Antarctica",
  //   code: "AQ",
  //   currency: "N/A",
  //   continent: "Antarctica",
  //   flag: "https://flagpedia.net/data/flags/h80/aq.webp",
  //   phone_code: "N/A",
  // },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    currency: "XCD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/ag.webp",
    phone_code: "1-268",
  },
  {
    name: "Argentina",
    code: "AR",
    currency: "ARS",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/ar.webp",
    phone_code: "54",
  },
  {
    name: "Armenia",
    code: "AM",
    currency: "AMD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/am.webp",
    phone_code: "374",
  },
  {
    name: "Aruba",
    code: "AW",
    currency: "AWG",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/aw.webp",
    phone_code: "297",
  },
  {
    name: "Australia",
    code: "AU",
    currency: "AUD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/au.webp",
    phone_code: "61",
  },
  {
    name: "Austria",
    code: "AT",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/at.webp",
    phone_code: "43",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
    currency: "AZN",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/az.webp",
    phone_code: "994",
  },
  {
    name: "Bahamas",
    code: "BS",
    currency: "BSD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/bs.webp",
    phone_code: "1-242",
  },
  {
    name: "Bahrain",
    code: "BH",
    currency: "BHD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/bh.webp",
    phone_code: "973",
  },
  {
    name: "Bangladesh",
    code: "BD",
    currency: "BDT",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/bd.webp",
    phone_code: "880",
  },
  {
    name: "Barbados",
    code: "BB",
    currency: "BBD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/bb.webp",
    phone_code: "1-246",
  },
  {
    name: "Belarus",
    code: "BY",
    currency: "BYR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/by.webp",
    phone_code: "375",
  },
  {
    name: "Belgium",
    code: "BE",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/be.webp",
    phone_code: "32",
  },
  {
    name: "Belize",
    code: "BZ",
    currency: "BZD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/bz.webp",
    phone_code: "501",
  },
  {
    name: "Benin",
    code: "BJ",
    currency: "XOF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/bj.webp",
    phone_code: "229",
  },
  {
    name: "Bermuda",
    code: "BM",
    currency: "BMD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/bm.webp",
    phone_code: "1-441",
  },
  {
    name: "Bhutan",
    code: "BT",
    currency: "BTN",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/bt.webp",
    phone_code: "975",
  },
  {
    name: "Bolivia",
    code: "BO",
    currency: "BOB",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/bo.webp",
    phone_code: "591",
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    code: "BQ",
    currency: "USD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/bq.webp",
    phone_code: "599",
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
    currency: "BAM",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/ba.webp",
    phone_code: "387",
  },
  {
    name: "Botswana",
    code: "BW",
    currency: "BWP",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/bw.webp",
    phone_code: "267",
  },
  {
    name: "Brazil",
    code: "BR",
    currency: "BRL",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/br.webp",
    phone_code: "55",
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
    currency: "USD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/io.webp",
    phone_code: "246",
  },
  {
    name: "British Virgin Islands",
    code: "VG",
    currency: "USD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/vg.webp",
    phone_code: "284",
  },
  {
    name: "Brunei Darussalam",
    code: "BN",
    currency: "BND",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/bn.webp",
    phone_code: "673",
  },
  {
    name: "Bulgaria",
    code: "BG",
    currency: "BGN",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/bg.webp",
    phone_code: "359",
  },
  {
    name: "Burkina Faso",
    code: "BF",
    currency: "XOF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/bf.webp",
    phone_code: "226",
  },
  {
    name: "Burundi",
    code: "BI",
    currency: "BIF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/bi.webp",
    phone_code: "257",
  },
  {
    name: "Cambodia",
    code: "KH",
    currency: "KHR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/kh.webp",
    phone_code: "855",
  },
  {
    name: "Cameroon",
    code: "CM",
    currency: "CFA",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/cm.webp",
    phone_code: "237",
  },
  {
    name: "Canada",
    code: "CA",
    currency: "CAD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/ca.webp",
    phone_code: "1",
  },
  // {
  //   name: "Cape Verde",
  //   code: "CV",
  //   currency: "CVE",
  //   continent: "Africa",
  //   flag: "https://flagpedia.net/data/flags/h80/cv.webp",
  //   phone_code: "238",
  // },
  {
    name: "Cayman Islands",
    code: "KY",
    currency: "KYD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/ky.webp",
    phone_code: "1-345",
  },
  {
    name: "Central African Republic",
    code: "CF",
    currency: "XAF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/cf.webp",
    phone_code: "236",
  },
  {
    name: "Chad",
    code: "TD",
    currency: "CDF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/td.webp",
    phone_code: "235",
  },
  {
    name: "Chile",
    code: "CL",
    currency: "CLP",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/cl.webp",
    phone_code: "56",
  },
  {
    name: "Christmas Island",
    code: "CX",
    currency: "AUD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/cx.webp",
    phone_code: "61",
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    currency: "AUD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/cc.webp",
    phone_code: "61",
  },
  {
    name: "Colombia",
    code: "CO",
    currency: "COP",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/co.webp",
    phone_code: "57",
  },
  {
    name: "Comoros",
    code: "KM",
    currency: "KMF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/km.webp",
    phone_code: "269",
  },
  {
    name: "Congo (Congo-Brazzaville)",
    code: "CG",
    currency: "CDF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/cg.webp",
    phone_code: "242",
  },
  {
    name: "Congo (Democratic Republic of the Congo)",
    code: "CD",
    currency: "CDF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/cd.webp",
    phone_code: "243",
  },
  {
    name: "Cook Islands",
    code: "CK",
    currency: "NZD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/ck.webp",
    phone_code: "682",
  },
  {
    name: "Costa Rica",
    code: "CR",
    currency: "CRC",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/cr.webp",
    phone_code: "506",
  },
  {
    name: "Côte d'Ivoire (Ivory Coast)",
    code: "CI",
    currency: "XOF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ci.webp",
    phone_code: "225",
  },
  {
    name: "Croatia",
    code: "HR",
    currency: "HRK",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/hr.webp",
    phone_code: "385",
  },
  {
    name: "Cuba",
    code: "CU",
    currency: "CUP",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/cu.webp",
    phone_code: "53",
  },
  {
    name: "Curaçao",
    code: "CW",
    currency: "AWG",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/cw.webp",
    phone_code: "599",
  },
  {
    name: "Cyprus",
    code: "CY",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/cy.webp",
    phone_code: "357",
  },
  {
    name: "Czech Republic",
    code: "CZ",
    currency: "CZK",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/cz.webp",
    phone_code: "420",
  },
  {
    name: "Denmark",
    code: "DK",
    currency: "DKK",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/dk.webp",
    phone_code: "45",
  },
  {
    name: "Djibouti",
    code: "DJ",
    currency: "DJF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/dj.webp",
    phone_code: "253",
  },
  {
    name: "Dominica",
    code: "DM",
    currency: "XCD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/dm.webp",
    phone_code: "1-767",
  },
  {
    name: "Dominican Republic",
    code: "DO",
    currency: "DOP",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/do.webp",
    phone_code: "1-809",
  },
  {
    name: "Ecuador",
    code: "EC",
    currency: "USD",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/ec.webp",
    phone_code: "593",
  },
  {
    name: "Egypt",
    code: "EG",
    currency: "EGP",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/eg.webp",
    phone_code: "20",
  },
  {
    name: "El Salvador",
    code: "SV",
    currency: "SVC",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/sv.webp",
    phone_code: "503",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
    currency: "GNF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/gq.webp",
    phone_code: "240",
  },
  {
    name: "Eritrea",
    code: "ER",
    currency: "ERN",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/er.webp",
    phone_code: "291",
  },
  {
    name: "Estonia",
    code: "EE",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/ee.webp",
    phone_code: "372",
  },
  {
    name: "Eswatini",
    code: "SZ",
    currency: "SZL",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/sz.webp",
    phone_code: "268",
  },
  {
    name: "Ethiopia",
    code: "ET",
    currency: "ETB",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/et.webp",
    phone_code: "251",
  },
  {
    name: "Falkland Islands",
    code: "FK",
    currency: "FKP",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/fk.webp",
    phone_code: "500",
  },
  {
    name: "Faroe Islands",
    code: "FO",
    currency: "DKK",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/fo.webp",
    phone_code: "298",
  },
  {
    name: "Fiji",
    code: "FJ",
    currency: "FJD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/fj.webp",
    phone_code: "679",
  },
  {
    name: "Finland",
    code: "FI",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/fi.webp",
    phone_code: "358",
  },
  {
    name: "France",
    code: "FR",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/fr.webp",
    phone_code: "33",
  },
  {
    name: "French Guiana",
    code: "GF",
    currency: "EUR",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/gf.webp",
    phone_code: "254",
  },
  {
    name: "French Polynesia",
    code: "PF",
    currency: "CFP",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/pf.webp",
    phone_code: "33",
  },
  {
    name: "French Southern Territories",
    code: "TF",
    currency: "EUR",
    continent: "Antarctica",
    flag: "https://flagpedia.net/data/flags/h80/tf.webp",
    phone_code: "33",
  },
  {
    name: "Gabon",
    code: "GA",
    currency: "GAB",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ga.webp",
    phone_code: "241",
  },
  {
    name: "Gambia",
    code: "GM",
    currency: "GMD",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/gm.webp",
    phone_code: "220",
  },
  {
    name: "Georgia",
    code: "GE",
    currency: "GEL",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/ge.webp",
    phone_code: "995",
  },
  {
    name: "Germany",
    code: "DE",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/de.webp",
    phone_code: "49",
  },
  {
    name: "Ghana",
    code: "GH",
    currency: "GHS",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/gh.webp",
    phone_code: "233",
  },
  {
    name: "Gibraltar",
    code: "GI",
    currency: "GIP",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/gi.webp",
    phone_code: "330",
  },
  {
    name: "Greece",
    code: "GR",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/gr.webp",
    phone_code: "30",
  },
  {
    name: "Greenland",
    code: "GL",
    currency: "DKK",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/gl.webp",
    phone_code: "299",
  },
  {
    name: "Grenada",
    code: "GD",
    currency: "XCD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/gd.webp",
    phone_code: "1-473",
  },
  {
    name: "Guadeloupe",
    code: "GP",
    currency: "EUR",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/gp.webp",
    phone_code: "590",
  },
  {
    name: "Guam",
    code: "GU",
    currency: "USD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/gu.webp",
    phone_code: "1-671",
  },
  {
    name: "Guatemala",
    code: "GT",
    currency: "GTQ",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/gt.webp",
    phone_code: "502",
  },
  {
    name: "Guinea",
    code: "GN",
    currency: "GNF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/gn.webp",
    phone_code: "224",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
    currency: "GNF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/gw.webp",
    phone_code: "245",
  },
  {
    name: "Guyana",
    code: "GY",
    currency: "GYD",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/gy.webp",
    phone_code: "592",
  },
  {
    name: "Haiti",
    code: "HT",
    currency: "HTG",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/ht.webp",
    phone_code: "509",
  },
  {
    name: "Heard Island and McDonald Islands",
    code: "HM",
    currency: "AUD",
    continent: "Australia",
    flag: "https://flagpedia.net/data/flags/h80/hm.webp",
    phone_code: "61",
  },
  {
    name: "Honduras",
    code: "HN",
    currency: "HNL",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/hn.webp",
    phone_code: "504",
  },
  {
    name: "Hong Kong",
    code: "HK",
    currency: "HKD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/hk.webp",
    phone_code: "852",
  },
  {
    name: "Hungary",
    code: "HU",
    currency: "HUF",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/hu.webp",
    phone_code: "36",
  },
  {
    name: "Iceland",
    code: "IS",
    currency: "ISK",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/is.webp",
    phone_code: "354",
  },
  {
    name: "India",
    code: "IN",
    currency: "INR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/in.webp",
    phone_code: "91",
  },
  {
    name: "Indonesia",
    code: "ID",
    currency: "IDR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/id.webp",
    phone_code: "62",
  },
  {
    name: "Iran",
    code: "IR",
    currency: "IRR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/ir.webp",
    phone_code: "98",
  },
  {
    name: "Iraq",
    code: "IQ",
    currency: "IQD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/iq.webp",
    phone_code: "964",
  },
  {
    name: "Ireland",
    code: "IE",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/ie.webp",
    phone_code: "353",
  },
  {
    name: "Isle of Man",
    code: "IM",
    currency: "IMP",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/im.webp",
    phone_code: "44",
  },

  {
    name: "Israel",
    code: "IL",
    currency: "ILS",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/il.webp",
    phone_code: "972",
  },
  {
    name: "Italy",
    code: "IT",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/it.webp",
    phone_code: "39",
  },
  {
    name: "Jamaica",
    code: "JM",
    currency: "JMD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/jm.webp",
    phone_code: "1-876",
  },
  {
    name: "Japan",
    code: "JP",
    currency: "JPY",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/jp.webp",
    phone_code: "81",
  },
  {
    name: "Jordan",
    code: "JO",
    currency: "JOD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/jo.webp",
    phone_code: "962",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
    currency: "KZT",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/kz.webp",
    phone_code: "7",
  },
  {
    name: "Kenya",
    code: "KE",
    currency: "KES",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ke.webp",
    phone_code: "254",
  },
  {
    name: "Kiribati",
    code: "KI",
    currency: "AUD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/ki.webp",
    phone_code: "686",
  },
  {
    name: "Korea (North)",
    code: "KP",
    currency: "KPW",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/kp.webp",
    phone_code: "850",
  },
  {
    name: "Korea (South)",
    code: "KR",
    currency: "KRW",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/kr.webp",
    phone_code: "82",
  },
  {
    name: "Kuwait",
    code: "KW",
    currency: "KWD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/kw.webp",
    phone_code: "965",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
    currency: "KGS",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/kg.webp",
    phone_code: "996",
  },
  {
    name: "Laos",
    code: "LA",
    currency: "LAK",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/la.webp",
    phone_code: "856",
  },
  {
    name: "Latvia",
    code: "LV",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/lv.webp",
    phone_code: "371",
  },
  {
    name: "Lebanon",
    code: "LB",
    currency: "LBP",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/lb.webp",
    phone_code: "961",
  },
  {
    name: "Lesotho",
    code: "LS",
    currency: "LSL",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ls.webp",
    phone_code: "266",
  },
  {
    name: "Liberia",
    code: "LR",
    currency: "LRD",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/lr.webp",
    phone_code: "231",
  },
  {
    name: "Libya",
    code: "LY",
    currency: "LYD",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ly.webp",
    phone_code: "218",
  },
  {
    name: "Liechtenstein",
    code: "LI",
    currency: "CHF",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/li.webp",
    phone_code: "423",
  },
  {
    name: "Lithuania",
    code: "LT",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/lt.webp",
    phone_code: "370",
  },
  {
    name: "Luxembourg",
    code: "LU",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/lu.webp",
    phone_code: "352",
  },
  {
    name: "Macau",
    code: "MO",
    currency: "MOP",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/mo.webp",
    phone_code: "853",
  },
  {
    name: "Madagascar",
    code: "MG",
    currency: "MGA",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/mg.webp",
    phone_code: "261",
  },
  {
    name: "Malawi",
    code: "MW",
    currency: "MWK",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/mw.webp",
    phone_code: "265",
  },
  {
    name: "Malaysia",
    code: "MY",
    currency: "MYR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/my.webp",
    phone_code: "60",
  },
  {
    name: "Maldives",
    code: "MV",
    currency: "MVR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/mv.webp",
    phone_code: "960",
  },
  {
    name: "Mali",
    code: "ML",
    currency: "XOF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ml.webp",
    phone_code: "223",
  },
  {
    name: "Malta",
    code: "MT",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/mt.webp",
    phone_code: "356",
  },
  {
    name: "Marshall Islands",
    code: "MH",
    currency: "USD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/mh.webp",
    phone_code: "692",
  },
  {
    name: "Martinique",
    code: "MQ",
    currency: "EUR",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/mq.webp",
    phone_code: "596",
  },
  {
    name: "Mauritania",
    code: "MR",
    currency: "MRU",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/mr.webp",
    phone_code: "222",
  },
  {
    name: "Mauritius",
    code: "MU",
    currency: "MUR",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/mu.webp",
    phone_code: "230",
  },
  {
    name: "Mayotte",
    code: "YT",
    currency: "EUR",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/yt.webp",
    phone_code: "269",
  },
  {
    name: "Mexico",
    code: "MX",
    currency: "MXN",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/mx.webp",
    phone_code: "52",
  },
  {
    name: "Micronesia",
    code: "FM",
    currency: "USD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/fm.webp",
    phone_code: "691",
  },
  {
    name: "Moldova",
    code: "MD",
    currency: "MDL",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/md.webp",
    phone_code: "373",
  },
  {
    name: "Monaco",
    code: "MC",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/mc.webp",
    phone_code: "377",
  },
  {
    name: "Mongolia",
    code: "MN",
    currency: "MNT",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/mn.webp",
    phone_code: "976",
  },
  {
    name: "Montenegro",
    code: "ME",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/me.webp",
    phone_code: "382",
  },
  {
    name: "Montserrat",
    code: "MS",
    currency: "XCD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/ms.webp",
    phone_code: "1-664",
  },
  {
    name: "Morocco",
    code: "MA",
    currency: "MAD",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ma.webp",
    phone_code: "212",
  },
  {
    name: "Mozambique",
    code: "MZ",
    currency: "MZN",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/mz.webp",
    phone_code: "258",
  },
  {
    name: "Myanmar",
    code: "MM",
    currency: "MMK",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/mm.webp",
    phone_code: "95",
  },
  {
    name: "Namibia",
    code: "NA",
    currency: "NAD",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/na.webp",
    phone_code: "264",
  },
  {
    name: "Nauru",
    code: "NR",
    currency: "AUD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/nr.webp",
    phone_code: "674",
  },
  {
    name: "Nepal",
    code: "NP",
    currency: "NPR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/np.webp",
    phone_code: "977",
  },
  {
    name: "Netherlands",
    code: "NL",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/nl.webp",
    phone_code: "31",
  },
  {
    name: "New Caledonia",
    code: "NC",
    currency: "XPF",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/nc.webp",
    phone_code: "687",
  },
  {
    name: "New Zealand",
    code: "NZ",
    currency: "NZD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/nz.webp",
    phone_code: "64",
  },
  {
    name: "Nicaragua",
    code: "NI",
    currency: "NIO",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/ni.webp",
    phone_code: "505",
  },
  {
    name: "Niger",
    code: "NE",
    currency: "NGN",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ne.webp",
    phone_code: "227",
  },
  {
    name: "Nigeria",
    code: "NG",
    currency: "NGN",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ng.webp",
    phone_code: "234",
  },
  {
    name: "Niue",
    code: "NU",
    currency: "NZD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/nu.webp",
    phone_code: "683",
  },
  {
    name: "Norfolk Island",
    code: "NF",
    currency: "AUD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/nf.webp",
    phone_code: "672",
  },
  {
    name: "North Macedonia",
    code: "MK",
    currency: "MKD",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/mk.webp",
    phone_code: "389",
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    currency: "USD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/mp.webp",
    phone_code: "1-670",
  },
  {
    name: "Norway",
    code: "NO",
    currency: "NOK",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/no.webp",
    phone_code: "47",
  },
  {
    name: "Oman",
    code: "OM",
    currency: "OMR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/om.webp",
    phone_code: "968",
  },
  {
    name: "Pakistan",
    code: "PK",
    currency: "PKR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/pk.webp",
    phone_code: "92",
  },
  {
    name: "Palau",
    code: "PW",
    currency: "USD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/pw.webp",
    phone_code: "680",
  },
  {
    name: "Panama",
    code: "PA",
    currency: "PAB",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/pa.webp",
    phone_code: "507",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    currency: "PGK",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/pg.webp",
    phone_code: "675",
  },
  {
    name: "Paraguay",
    code: "PY",
    currency: "PYG",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/py.webp",
    phone_code: "595",
  },
  {
    name: "Peru",
    code: "PE",
    currency: "PEN",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/pe.webp",
    phone_code: "51",
  },
  {
    name: "People's Republic of China (PRC)",
    code: "CN",
    currency: "CNY",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/cn.webp",
    phone_code: "86",
  },
  {
    name: "Philippines",
    code: "PH",
    currency: "PHP",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/ph.webp",
    phone_code: "63",
  },
  {
    name: "Pitcairn Islands",
    code: "PN",
    currency: "NZD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/pn.webp",
    phone_code: "64",
  },
  {
    name: "Poland",
    code: "PL",
    currency: "PLN",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/pl.webp",
    phone_code: "48",
  },
  {
    name: "Portugal",
    code: "PT",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/pt.webp",
    phone_code: "351",
  },
  {
    name: "Puerto Rico",
    code: "PR",
    currency: "USD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/pr.webp",
    phone_code: "1-787",
  },
  {
    name: "Qatar",
    code: "QA",
    currency: "QAR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/qa.webp",
    phone_code: "974",
  },
  {
    name: "Romania",
    code: "RO",
    currency: "RON",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/ro.webp",
    phone_code: "40",
  },
  {
    name: "Russia",
    code: "RU",
    currency: "RUB",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/ru.webp",
    phone_code: "7",
  },
  {
    name: "Rwanda",
    code: "RW",
    currency: "RWF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/rw.webp",
    phone_code: "250",
  },
  {
    name: "Saint Barthélemy",
    code: "BL",
    currency: "EUR",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/bl.webp",
    phone_code: "590",
  },
  {
    name: "Saint Helena",
    code: "SH",
    currency: "SHP",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/sh.webp",
    phone_code: "290",
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    currency: "XCD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/kn.webp",
    phone_code: "1-869",
  },
  {
    name: "Saint Lucia",
    code: "LC",
    currency: "XCD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/lc.webp",
    phone_code: "1-758",
  },
  {
    name: "Saint Martin",
    code: "MF",
    currency: "EUR",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/mf.webp",
    phone_code: "590",
  },
  {
    name: "Saint Pierre and Miquelon",
    code: "PM",
    currency: "EUR",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/pm.webp",
    phone_code: "508",
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    currency: "XCD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/vc.webp",
    phone_code: "1-784",
  },
  {
    name: "Samoa",
    code: "WS",
    currency: "WST",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/ws.webp",
    phone_code: "685",
  },
  {
    name: "San Marino",
    code: "SM",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/sm.webp",
    phone_code: "378",
  },
  {
    name: "Sao Tome and Principe",
    code: "ST",
    currency: "STN",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/st.webp",
    phone_code: "239",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
    currency: "SAR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/sa.webp",
    phone_code: "966",
  },
  {
    name: "Senegal",
    code: "SN",
    currency: "XOF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/sn.webp",
    phone_code: "221",
  },
  {
    name: "Serbia",
    code: "RS",
    currency: "RSD",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/rs.webp",
    phone_code: "381",
  },
  {
    name: "Seychelles",
    code: "SC",
    currency: "SCR",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/sc.webp",
    phone_code: "248",
  },
  {
    name: "Sierra Leone",
    code: "SL",
    currency: "SLL",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/sl.webp",
    phone_code: "232",
  },
  {
    name: "Singapore",
    code: "SG",
    currency: "SGD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/sg.webp",
    phone_code: "65",
  },
  {
    name: "Sint Eustatius",
    code: "SX",
    currency: "USD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/sx.webp",
    phone_code: "599",
  },
  {
    name: "Sint Maarten",
    code: "SM",
    currency: "ANG",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/sm.webp",
    phone_code: "1-721",
  },
  {
    name: "Slovakia",
    code: "SK",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/sk.webp",
    phone_code: "421",
  },
  {
    name: "Slovenia",
    code: "SI",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/si.webp",
    phone_code: "386",
  },
  {
    name: "Solomon Islands",
    code: "SB",
    currency: "SBD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/sb.webp",
    phone_code: "677",
  },
  {
    name: "Somalia",
    code: "SO",
    currency: "SOS",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/so.webp",
    phone_code: "252",
  },
  {
    name: "South Africa",
    code: "ZA",
    currency: "ZAR",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/za.webp",
    phone_code: "27",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS",
    currency: "GBP",
    continent: "Antarctica",
    flag: "https://flagpedia.net/data/flags/h80/gs.webp",
    phone_code: "500",
  },
  {
    name: "South Sudan",
    code: "SS",
    currency: "SSP",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ss.webp",
    phone_code: "211",
  },
  {
    name: "Spain",
    code: "ES",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/es.webp",
    phone_code: "34",
  },
  {
    name: "Sri Lanka",
    code: "LK",
    currency: "LKR",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/lk.webp",
    phone_code: "94",
  },
  {
    name: "Sudan",
    code: "SD",
    currency: "SDG",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/sd.webp",
    phone_code: "249",
  },
  {
    name: "Suriname",
    code: "SR",
    currency: "SRD",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/sr.webp",
    phone_code: "597",
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "SJ",
    currency: "NOK",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/sj.webp",
    phone_code: "47",
  },
  {
    name: "Sweden",
    code: "SE",
    currency: "SEK",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/se.webp",
    phone_code: "46",
  },
  {
    name: "Switzerland",
    code: "CH",
    currency: "CHF",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/ch.webp",
    phone_code: "41",
  },
  {
    name: "Syria",
    code: "SY",
    currency: "SYP",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/sy.webp",
    phone_code: "963",
  },
  {
    name: "Taiwan",
    code: "TW",
    currency: "TWD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/tw.webp",
    phone_code: "886",
  },
  {
    name: "Tajikistan",
    code: "TJ",
    currency: "TJS",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/tj.webp",
    phone_code: "992",
  },
  {
    name: "Tanzania",
    code: "TZ",
    currency: "TZS",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/tz.webp",
    phone_code: "255",
  },
  {
    name: "Thailand",
    code: "TH",
    currency: "THB",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/th.webp",
    phone_code: "66",
  },
  {
    name: "Timor-Leste",
    code: "TL",
    currency: "USD",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/tl.webp",
    phone_code: "670",
  },
  {
    name: "Togo",
    code: "TG",
    currency: "XOF",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/tg.webp",
    phone_code: "228",
  },
  {
    name: "Tokelau",
    code: "TK",
    currency: "NZD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/tk.webp",
    phone_code: "690",
  },
  {
    name: "Tonga",
    code: "TO",
    currency: "TOP",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/to.webp",
    phone_code: "676",
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    currency: "TTD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/tt.webp",
    phone_code: "1-868",
  },
  {
    name: "Tunisia",
    code: "TN",
    currency: "TND",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/tn.webp",
    phone_code: "216",
  },
  {
    name: "Turkey",
    code: "TR",
    currency: "TRY",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/tr.webp",
    phone_code: "90",
  },
  {
    name: "Turkmenistan",
    code: "TM",
    currency: "TMT",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/tm.webp",
    phone_code: "993",
  },
  {
    name: "Tuvalu",
    code: "TV",
    currency: "AUD",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/tv.webp",
    phone_code: "688",
  },
  {
    name: "Uganda",
    code: "UG",
    currency: "UGX",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/ug.webp",
    phone_code: "256",
  },
  {
    name: "Ukraine",
    code: "UA",
    currency: "UAH",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/ua.webp",
    phone_code: "380",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    currency: "AED",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/ae.webp",
    phone_code: "971",
  },
  {
    name: "United Kingdom",
    code: "GB",
    currency: "GBP",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/gb.webp",
    phone_code: "44",
  },
  {
    name: "United States",
    code: "US",
    currency: "USD",
    continent: "North America",
    flag: "https://flagpedia.net/data/flags/h80/us.webp",
    phone_code: "1",
  },
  {
    name: "Uruguay",
    code: "UY",
    currency: "UYU",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/uy.webp",
    phone_code: "598",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
    currency: "UZS",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/uz.webp",
    phone_code: "998",
  },
  {
    name: "Vanuatu",
    code: "VU",
    currency: "VUV",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/vu.webp",
    phone_code: "678",
  },
  {
    name: "Vatican City",
    code: "VA",
    currency: "EUR",
    continent: "Europe",
    flag: "https://flagpedia.net/data/flags/h80/va.webp",
    phone_code: "379",
  },
  {
    name: "Venezuela",
    code: "VE",
    currency: "VES",
    continent: "South America",
    flag: "https://flagpedia.net/data/flags/h80/ve.webp",
    phone_code: "58",
  },
  {
    name: "Vietnam",
    code: "VN",
    currency: "VND",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/vn.webp",
    phone_code: "84",
  },
  {
    name: "Wallis and Futuna",
    code: "WF",
    currency: "XPF",
    continent: "Oceania",
    flag: "https://flagpedia.net/data/flags/h80/wf.webp",
    phone_code: "681",
  },
  {
    name: "Western Sahara",
    code: "EH",
    currency: "MAD",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/eh.webp",
    phone_code: "212",
  },
  {
    name: "Yemen",
    code: "YE",
    currency: "YER",
    continent: "Asia",
    flag: "https://flagpedia.net/data/flags/h80/ye.webp",
    phone_code: "967",
  },
  {
    name: "Zambia",
    code: "ZM",
    currency: "ZMW",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/zm.webp",
    phone_code: "260",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    currency: "ZWL",
    continent: "Africa",
    flag: "https://flagpedia.net/data/flags/h80/zw.webp",
    phone_code: "263",
  },
];
